// extracted by mini-css-extract-plugin
export default {"containerGlobal":"ClearStock_containerGlobal__ZUmVO","container":"ClearStock_container__ty5sA","titleMenu":"ClearStock_titleMenu__gbI2w","div":"ClearStock_div__BBK4d"};